export default "__VITE_ASSET__88d041c0__"